import React from 'react'

import {FieldControlViewProps} from "../../../../render/control-view"
import {FieldViewSize} from "../../../../const"
import {isEqualMomentRange} from "../../../../../gd/utils/datetime/is-equal-moment-range"

type State = {
    initialPropsValue   : any, // required to check if currentOption update needed on props changed
    currentValue        : any,
    showPopover         : boolean
}

// const debug = "FieldDateRange_ControlView"
const debug = false

export default class FieldDateRange_ControlView extends React.Component<FieldControlViewProps, State> {

    public previousValue        : any

    public static defaultProps  = {
        size        : FieldViewSize.DEFAULT
    }

    constructor(props:FieldControlViewProps) {
        super(props);

        const value = props.field.getViewValue(props.model)

        debug && console.log(debug,"constructor initValue=", value)

        this.state = {
            initialPropsValue   : value, // required to check if currentValue update needed on props changed
            currentValue        : value,
            showPopover         : false,
        }
    }

    // We need to redefine it as we compare dateranges and simple != doesn't work at all
    // we need a better function for the future I guess
    static getDerivedStateFromProps(props:any, state:any) {

        const newValue = props.field.getViewValue(props.model)

        debug && console.log(debug, "getDerivedStateFromProps newValue=", newValue)

        // if (newValue !== state.initialPropsValue) {
        if (!isEqualMomentRange(state.initialPropsValue, newValue)) {

            debug && console.log(debug, "props have changed - apply to state and set initialPropsValue")

            return {
                initialPropsValue   : newValue,
                currentValue        : newValue
            }
        }
        return null
    }

    showPopover = (e?:React.SyntheticEvent) => {
        e?.stopPropagation()
        if (!this.state.showPopover) this.setState({showPopover: true})
    }

    public hidePopover = () => {
        if (this.state.showPopover) this.setState({showPopover: false})
    }


    onValueChange = (value:any, hidePopover: boolean = true) => {

        debug && console.log(debug, "onValueChange", value)

        this.previousValue  = this.state.currentValue;
        const newValue      = value; //_.get(option, 'value', null);

        this.setState({
            currentValue: newValue
        }, () => {
            if (this.props.onChange) this.props.onChange(newValue, this.onCancelChange);
            if (hidePopover) this.hidePopover()
        });
    }

    onCancelChange = () => {
        this.setState({
            currentValue: this.previousValue
        });
    }

    render() {

        debug && console.log(debug, "render()", this.state, this.props.field)

        const {field} = this.props;

        const classes = Classes(this.props.className, {
            'show-popover' : this.state.showPopover,
        });


        // need check value because of none
        if (this.state.currentValue && (!Array.isArray(this.state.currentValue) || !_.isEmpty(this.state.currentValue))) {
            return (
                <field.components.ControlViewNotEmpty className={classes}
                                                      field={this.props.field}
                                                      value={this.state.currentValue}
                                                      configOptions={this.props.configOptions}
                                                      onClick={this.showPopover}
                                                      onChange={this.onValueChange}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} value={this.state.currentValue} />}
                </field.components.ControlViewNotEmpty>
            );
        } else {
            return (
                <field.components.ControlViewEmpty className={classes}
                                                   field={this.props.field}
                                                   configOptions={this.props.configOptions}
                                                   onClick={this.showPopover}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
                </field.components.ControlViewEmpty>
            );
        }
    }
}
